<template>
    <div class="index-footer">
        <div class="index-footer-companyName">
            {{ $t('logo.lastName')}}
        </div>
        <div class="index-footer-contact">
            <div class="index-footer-contact-phone">
                {{$t('footer.phone')}}：+8618208199075 {{$t('footer.contact')}}
            </div>
            <div class="index-footer-contact-email">
                {{$t('footer.email')}}：dorothy@sdblo.com
            </div>
            <div class="index-footer-contact-email" style="transform: scale(.9)">
                Copyright © 2017 Sdblo. 成都赛德部落科技有限公司 All Rights Reserved. 蜀ICP备16006428号-4
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Footer",
    }
</script>

<style scoped lang="scss" src="./footer.scss"></style>
